import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Button, Box } from '@mui/material';
import { CloudUpload, FileUpload } from '@mui/icons-material';
import { PALETTE, alpha} from '../theme';

const uploadControlId = 'uploadControlId';

class ImageUpload extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            file: '', 
            imagePreviewUrl: '', 
            selected: false,
            isDragOver: false,
            isUploading: false
        };
    }

    onChangeFile = (file = null) => {
        if (!file) {
            const fileButton = document.getElementById(uploadControlId);
            file = fileButton ? fileButton.files[0] : null;
        }

        if (!file) return;

        this.setState({ isUploading: true });

        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                file: file,
                selected: true,
                imagePreviewUrl: reader.result,
                isUploading: false
            });

            this.props.onSelected({
                file: file,
                uri: reader.result
            });
        };

        reader.onerror = () => {
            this.setState({ isUploading: false });
        };

        reader.readAsDataURL(file);
    };

    handleDragOver = (e) => {
        e.preventDefault();
        this.setState({ isDragOver: true });
    };

    handleDragLeave = (e) => {
        e.preventDefault();
        this.setState({ isDragOver: false });
    };

    handleDrop = (e) => {
        e.preventDefault();
        this.setState({ isDragOver: false });
        
        const files = e.dataTransfer.files;
        if (files && files[0]) {
            this.onChangeFile(files[0]);
        }
    };

    render() {
        return (
            <Box
                className="previewComponent"
                sx={{
                    display: { xs: 'block', sm: 'inline-block' },
                    width: { xs: '100%', sm: 'auto' },
                    position: 'relative'
                }}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        border: `2px dashed ${this.state.isDragOver ? PALETTE.primary : 'transparent'}`,
                        borderRadius: 2,
                        backgroundColor: this.state.isDragOver ? alpha('primary', 0.1) : 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'none',
                        transition: 'all 0.3s ease',
                        zIndex: 1,
                        opacity: this.state.isDragOver ? 1 : 0,
                        transform: this.state.isDragOver ? 'scale(1.05)' : 'scale(1)',
                    }}
                >
                    <Box sx={{ textAlign: 'center', color: PALETTE.primary }}>
                        <FileUpload sx={{ fontSize: 40, mb: 1 }} />
                        <Box sx={{ fontWeight: 'bold', fontSize: '14px' }}>Drop your photo here</Box>
                    </Box>
                </Box>

                <Button
                    component="label"
                    variant={this.state.selected ? "contained" : "outlined"}
                    startIcon={this.state.isUploading ? <CloudUpload /> : <CloudUpload />}
                    disabled={this.state.isUploading}
                    sx={{
                        width: { xs: '100%', sm: '160px' },
                        height: '48px',
                        borderRadius: 2,
                        fontWeight: 'bold',
                        textTransform: 'none',
                        position: 'relative',
                        zIndex: 2,
                        ...(this.state.selected ? {
                            background: 'linear-gradient(45deg, #4caf50, #45a049)',
                            color: 'white',
                            boxShadow: '0 4px 15px rgba(76, 175, 80, 0.4)',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 8px 25px rgba(76, 175, 80, 0.6)',
                            }
                        } : {
                            borderColor: PALETTE.primary,
                            color: PALETTE.primary,
                            '&:hover': {
                                backgroundColor: PALETTE.primary,
                                color: 'white',
                                transform: 'translateY(-2px)',
                                boxShadow: `0 8px 25px ${alpha('primary', 0.4)}`,
                            }
                        }),
                        transition: 'all 0.3s ease',
                        '&:disabled': {
                            opacity: 0.7
                        }
                    }}
                    htmlFor={uploadControlId}
                >
                    {this.state.isUploading ? 'Uploading...' : 
                     this.state.selected ? 'Change Photo' : 'Upload Photo'}
                </Button>
                <input
                    type="file"
                    accept="image/*"
                    id={uploadControlId}
                    hidden
                    onChange={() => this.onChangeFile()}
                />
            </Box>
        );
    }
}

ImageUpload.propTypes = {
    onSelected: PropTypes.func.isRequired,
    fileId: PropTypes.string.isRequired
};

export default ImageUpload;